import { Children, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { bridge } from "../../utils/bridge";
import { SHOW_BACK_BUTTON } from "../../constants/types/commands";
import { handleBrowserClass } from "./handle-browser-class";
import { useSendCommand } from "../../hooks/use-send-command";
import { useSetBaseFontSizeEffect } from "./use-set-base-font-size-effect";

export const InboxController = ({
    children,
    fixedFontSize,
}: {
    children: React.ReactNode;
    fixedFontSize?: string;
}) => {
    const location = useLocation();
    const sendCommand = useSendCommand();

    useSetBaseFontSizeEffect(fixedFontSize);

    useEffect(() => {
        handleBrowserClass();
        (async () => {
            const { show } = await bridge();
            show?.();
        })();
    }, []);

    useEffect(() => {
        const { state } = window.history;
        const isHome = state && state.home;

        sendCommand(SHOW_BACK_BUTTON, !isHome);
    }, [location]);

    return Children.only(children);
};
